export const isMobile = !window.matchMedia("(pointer: coarse)").matches;
